import { useDispatch, useSelector } from "react-redux"
import {
    useFetchWithBody,
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_ADVSEARCH_PARAM, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_POLISH_PRICE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funGetFormatCurrency, GetLoginCredentialDb, getModMandatory, getModValue, getModVisiblity, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NoItemsCard,
    WarningDialog,
} from "../../components"
import {
    Autocomplete,
    AutocompleteItem,
    Button,
    Checkbox,
    form,
    Input,
    Card,
    CardBody,

} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faCancel,
    faClose,
    faDownload,
    faFileExcel,
    faPenToSquare,
    faPlus,
    faRemove,
    faSave,
    faSearchPlus,
    faSquareXmark,
    faTrash,
} from "@fortawesome/free-solid-svg-icons"


import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useRef, useState } from "react"
import { calculateTotal, formatCurrency } from "../../Utility/utility"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Box, Drawer, FormControl, InputLabel, MenuItem, Select, Chip } from "@mui/material"
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import AutoCompleteInput from "../../components/AutoCompleteInput"


const PriceListEntry = () => {
    let disapatch = useDispatch()
    let navigate = useNavigate()
    const { compCode, isMultipleCompany, yearId, CurrencyFormatBy } = useSelector((state) => state.company)
    const { user, token } = useSelector((state) => state.auth)
    const [itemToDelete, setItemToDelete] = useState("")
    const [selPriceType, setSelPriceType] = useState("")
    const [selLwData, setSelLwData] = useState([])
    const [rows, setRows] = useState([])
    const [selectedRowId, setSelectedRowId] = useState("")
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selRateDate, setSelRateDate] = useState(dayjs(new Date()).format("YYYY-MM-DD") || null);
    const [btnLabel, setBtnLabel] = useState("ADD")
    const { show } = useModalToast();
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [allRows, setAllRows] = useState([])
    const [modSettingParams, setModSettingParams] = useState("")
    const [isExcelImport, setIsExcelImport] = useState(false)
    const [isShowDialog, setIsShowDialog] = useState(false)
    const [searchText, setSearchText] = useState("")
    const submitLockRef = useRef(false)
    const fileInputRef = useRef(null)
    const [duplicateRows, setDuplicateRows] = useState([]);
    const formField = {
        detId: "detId",
        shapeCode: 's_code',
        sizeCode: 'sz_code',
        colorCode: 'sh_code',
        purityCode: 'q_code',
        lwCode: 'lw_code',
        rate: 'Pr_Rate',
        rateD: 'Pr_RateD',
        shapeName: 's_name',
        sizeName: 'sz_name',
        colorName: 'sh_name',
        purityName: 'q_name',
    }
    const emptyFormField = {
        [formField.detId]: 0,
        [formField.shapeCode]: '',
        [formField.sizeCode]: '',
        [formField.colorCode]: '',
        [formField.purityCode]: '',
        [formField.lwCode]: '',
        [formField.rate]: 0,
        [formField.rateD]: 0,
        [formField.shapeName]: '',
        [formField.sizeName]: '',
        [formField.colorName]: '',
        [formField.purityName]: '',
    }

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "fetchParamMasterData",
    });


    const { data: excelTempData, } = useFetchWithBody({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",
        inputData: {
            tempname: "PolishPriceImport"
        }

    })
    const { data: priceTypeData = [] } = useFetchWithBody({
        url: apiRoute.polishRateEntry.getPriceType,
        queryKey: "PriceTypeMaster",
    })
    const { data: prDateList = [] } = useFetchWithBody({
        url: apiRoute.polishRateEntry.getPrDate,
        queryKey: "PrdateMaster",
    })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)

    }, [])

    useEffect(() => {

        if (selRateDate != "" && selRateDate != null && selRateDate != 'Invalid Date' && selPriceType != "" && selPriceType != null) {



            funFilterData(selRateDate, selPriceType);
        }

    }, [selRateDate, selPriceType])

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingCurrency",
        inputData: {
            mod_name: ENUM_MOD_NAME.PolishPriceList
        }
    })


    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const modData = modSetting
            setModSettingParams({
                Visibility: {
                    [formField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [formField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [formField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [formField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [formField.lwCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                },
                Mandatory: {
                    [formField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [formField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [formField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [formField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [formField.lwCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,

                },



            })
        }
    }, [modSetting])
    const setColumnRequired = (column) => {
        if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }

    const setColumnVisiblity = (column) => {
        if ([formField.rate, formField.rateD].includes(column))
            return true
        else {
            if (modSetting && Object.keys(modSetting).length > 0) {
                return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
            }
            else
                return true
        }
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }
    const [errors, setErrors] = useState({})
    const validateForm = () => {
        const newErrors = {}

        // Validate username

        if (setColumnRequired(formField.shapeCode)) {
            if (formData[formField.shapeCode] == "" || formData[formField.shapeCode] == "0" || formData[formField.shapeCode] == null) {
                newErrors[formField.shapeCode] = "Shape required"
            }
        }
        if (setColumnRequired(formField.colorCode)) {

            if (formData[formField.colorCode] == "" || formData[formField.colorCode] == "0" || formData[formField.colorCode] == null) {
                newErrors[formField.colorCode] = "Color required"
            }
        }
        if (setColumnRequired(formField.purityCode)) {
            if (formData[formField.purityCode] == "" || formData[formField.purityCode] == "0" || formData[formField.purityCode] == null) {
                newErrors[formField.purityCode] = "Purity required"
            }

        }
        if (setColumnRequired(formField.sizeCode)) {
            if (formData[formField.sizeCode] == "" || formData[formField.sizeCode] == "0" || formData[formField.sizeCode] == null) {
                newErrors[formField.sizeCode] = "Size required"
            }
        }

        if (setColumnRequired(formField.lwCode)) {
            if (formData[formField.lwCode] == "" || formData[formField.lwCode] == "0" || formData[formField.lwCode] == null) {
                newErrors[formField.lwCode] = "LXW required"
            }
        }


        if (formData[formField.rate] == "" || formData[formField.rate] <= 0) {
            newErrors[formField.rate] = "Rate required"
        }


        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    const {
        isError: isErrorDel,
        isPending: isPendingDel,
        mutate: FndeleteEntry
    } = usePost({
        url: apiRoute.polishRateEntry.deleteEntry,
        queryKey: "Delete Data List",
        onSuccessTasks: (data) => {
            setItemToDelete("")
            setSelPriceType("")
            setIsExcelImport(false)
            funFilterData(selRateDate, selPriceType);
            setDuplicateRows("")

        }
    })


    const {
        isError,
        isPending,
        data: priceData = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.polishRateEntry.fetch,
        queryKey: "Price Data List",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                const gridData = data?.map((item, i) => {
                    return {
                        id: ++i,
                        [formField.detId]: item?.DetId || 0,
                        [formField.purityCode]: item?.q_code || "",
                        [formField.purityName]: item?.q_name || "",
                        [formField.shapeCode]: item?.s_code || "",
                        [formField.shapeName]: item?.s_name || "",
                        [formField.sizeCode]: item?.sz_code || "",
                        [formField.sizeName]: item?.sz_name || "",
                        [formField.colorCode]: item?.sh_code || "",
                        [formField.colorName]: item?.sh_name || "",
                        [formField.rate]: item?.Pr_Rate || "",
                        [formField.rateD]: item?.Pr_RateD || "",
                        [formField.lwCode]: item?.lw_code || "",
                    }
                })
                setRows(gridData)
                setAllRows(gridData)
            }
            else {
                setRows([])
                setAllRows([])
            }
        }

    })

    const {
        isError: isErrorUpdate,
        isPending: isPendingUpdate,
        mutate: funUpdate
    } = usePost({
        url: apiRoute.polishRateEntry.addUpdate,
        queryKey: "Invoice Data List",
        onSuccessTasks: (data) => {
            show("Insert/Update  Successfully");
            setOpenDrawer(false)
            funFilterData(selRateDate, selPriceType);
            setIsExcelImport(false)
            setDuplicateRows("")
        }

    })

    const funFilterData = (rateDate, priceType) => {

        filterData({
            data: {
                rate_date: rateDate,
                price_type: priceType
            }
        })

    }




    let totalAmt = useMemo(
        () => {
            const total = calculateTotal({
                data: rows,
                columnName: formField.rate,
            })
            return CurrencyFormatBy && CurrencyFormatBy != "" ? funGetFormatCurrency(total, CurrencyFormatBy) : total
        },
        [rows]
    )
    let totalAmtD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: formField.rateD,
            }),
        [rows]
    )
    const inputBoxes = {
        Row1: [
            {
                id: formField.shapeCode,
                name: formField.shapeCode,
                placeholder: "Shape",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData?.shapeMaster || [],
                itemkey: "S_Code",
                itemvalue: "S_Name",
                isrequired: false,
            },
            {
                id: formField.sizeCode,
                name: formField.sizeCode,
                placeholder: "Size",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData?.sizeMaster || [],
                itemkey: "Sz_Code",
                itemvalue: "Sz_Name",
                isrequired: false,
            },],
        Row2: [
            {
                id: formField.purityCode,
                name: formField.purityCode,
                placeholder: "Purity",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData?.purityMaster || [],
                itemkey: "Q_Code",
                itemvalue: "Q_Name",
                isrequired: false,
            },
            {
                id: formField.colorCode,
                name: formField.colorCode,
                placeholder: "Color",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData?.colorMaster || [],
                itemkey: "Sh_Code",
                itemvalue: "Sh_Name",
                isrequired: false,
            },
            {
                id: formField.LwCode,
                name: formField.LwCode,
                placeholder: "L X W",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: selLwData || [],
                itemkey: "LwCode",
                itemvalue: "LwCode",
                isrequired: false,
            },
        ],
        Row3: [
            {
                id: formField.rate,
                name: formField.rate,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.rateD,
                name: formField.rateD,
                placeholder: "Rate ($)",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ]

    }
    const getLwRatioByShape = (shape) => {
        if (masterData && Object.keys(masterData).length > 0)
            return masterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        const rearrangedRows = updatedRows.map((row, index) => {
            return {
                ...row,
                id: index + 1
            } // Reassign IDs to start from 1 again
        })
        setRows(rearrangedRows)
        setAllRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])

    }

    const handleEditRow = (id) => {
        const editRow = rows.filter((row) => row.id == id)
        setSelLwData(getLwRatioByShape(editRow[0]?.[formField?.shapeCode] ?? ''))
        setFormData(...editRow)
        setSelectedRowId(id)
        setOpenDrawer(true)
        setBtnLabel("Update")

    }

    const itemGridHeadClass = "bill-grid-style"
    const columns = [
        {
            field: "id",
            headerName: "Action",
            width: 70,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>

                    <div className="flex justify-evenly" ><h6> {row.id}</h6>
                        <strong>
                            <FontAwesomeIcon
                                color="red"
                                className={` mx-2 cursor-pointer`}
                                onClick={() => handleDeleteRow(row.id)}
                                icon={faSquareXmark}
                            ></FontAwesomeIcon>

                            <FontAwesomeIcon
                                color="green"
                                className={`  cursor-pointer`}
                                onClick={() => handleEditRow(row.id)}
                                icon={faPenToSquare}
                            ></FontAwesomeIcon>


                        </strong>
                    </div>
                </div>
            ),
        },
        {
            field: formField.purityCode,
            headerName: "Purity",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.purityName]}

                </div>)
        },
        {
            field: formField.sizeCode,
            headerName: "Size",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.sizeName]}

                </div>)
        },

        {
            field: formField.colorCode,
            headerName: "Color",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.colorName]}

                </div>)
        },
        {
            field: formField.shapeCode,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.shapeName]}

                </div>)
        },
        {
            field: formField.rate,
            headerName: "Rate",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.rate]}

                </div>)
        },
        {
            field: formField.rateD,
            headerName: "Rate ($)",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[formField.rateD]}

                </div>)
        },
    ]

    const funGetName = (columName, value) => {
        let name_val = ""
        let tempData = []
        let findData = []

        if (masterData && Object.keys(masterData).length > 0) {

            if (columName == formField.shapeCode && value != "" && value != null) {
                tempData = masterData.shapeMaster
                findData = tempData.filter((ele) => ele.S_Code == value)
                name_val = findData[0]?.S_Name ?? ''
            }
            else if (columName == formField.colorCode && value != "" && value != null) {
                tempData = masterData.colorMaster
                findData = tempData.filter((ele) => ele.Sh_Code == value)
                name_val = findData[0]?.Sh_Name ?? ''
            }
            else if (columName == formField.purityCode && value != "" && value != null) {
                tempData = masterData.purityMaster
                findData = tempData.filter((ele) => ele.Q_Code == value)
                name_val = findData[0]?.Q_Name ?? ''
            }
            else if (columName == formField.sizeCode && value != "" && value != null) {
                tempData = masterData.sizeMaster
                findData = tempData.filter((ele) => ele.Sz_Code == value)
                name_val = findData[0]?.Sz_Name ?? ''
            }
        }

        return name_val;

    }

    const funGetCode = (columName, value) => {
        let name_val = "";

        const normalize = (val) => String(val ?? "").trim().toLowerCase();

        if (masterData && Object.keys(masterData).length > 0) {

            if (columName === formField.shapeCode && normalize(value) !== "") {
                const findData = masterData.shapeMaster?.find(
                    ele => normalize(ele.S_Name) === normalize(value)
                );
                name_val = findData?.S_Code ?? "";
            }
            else if (columName === formField.colorCode && normalize(value) !== "") {
                const findData = masterData.colorMaster?.find(
                    ele => normalize(ele.Sh_Name) === normalize(value)
                );
                name_val = findData?.Sh_Code ?? "";
            }
            else if (columName === formField.purityCode && normalize(value) !== "") {
                const findData = masterData.purityMaster?.find(
                    ele => normalize(ele.Q_Name) === normalize(value)
                );
                name_val = findData?.Q_Code ?? "";
            }
            else if (columName === formField.sizeCode && normalize(value) !== "") {

                const findData = masterData.sizeMaster?.find(
                    ele => normalize(ele.Sz_Name) === normalize(value)
                );
                name_val = findData?.Sz_Code ?? "";
            }
        }

        return name_val;
    };

    const compactSelectSx = {
        height: 36,
        borderRadius: "8px",
        backgroundColor: "#fff",
        fontSize: "13px",
        "& .MuiSelect-select": {
            padding: "8px 10px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c7d2fe",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#818cf8",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#4f46e5",
            borderWidth: "1.5px",
        },
    };

    const datePickerSx = {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            height: 36,
            borderRadius: "8px",
            backgroundColor: "#fff",
            fontSize: "12px",
            "& fieldset": {
                borderColor: "#c7d2fe",
            },
            "&:hover fieldset": {
                borderColor: "#818cf8",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#4f46e5",
                borderWidth: "1.5px",
            },
        },
        "& .MuiInputBase-input": {
            fontSize: "12px",
            fontWeight: 500,
            color: "#334155",
            padding: "8px 8px",
        },
        "& .MuiInputLabel-root": {
            fontSize: "14px",
            fontWeight: 600,
            color: "#475569",
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#4f46e5",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "18px",
            color: "#6366f1",
        },
    };

    const handleAutoCompleteChange = (value, id, name) => {
        if ([formField.rate, formField.rateD].includes(name)) {
            setFormData({ ...formData, [name]: value })
        }
        else {

            let name_key = ""

            if (name == formField.shapeCode) {
                name_key = formField.shapeName
                setSelLwData(getLwRatioByShape(value))
            }
            else if (name == formField.colorCode)
                name_key = formField.colorName
            else if (name == formField.purityCode)
                name_key = formField.purityName
            else if (name == formField.sizeCode)
                name_key = formField.sizeName

            let name_val = funGetName(name, value)
            if (name == formField.lwRatio) {
                name_key = formField.lwRatio
                name_val = value

            }
            setFormData({ ...formData, [name]: value, [name_key]: name_val })
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);
        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");

        setSelRateDate(formatted);

    };
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                shipmentDate: cdate,
            };
        });

    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (selPriceType == '' || selPriceType == null) {
            show("Select / Enter Price Type")
            return;
        }
        const grid_msg = ValidateGrid()

        if (grid_msg == "") {
            funUpdate({
                data: {
                    rate_date: selRateDate,
                    price_type: selPriceType,
                    item_list: rows,
                    action: 'PriceListEntry',
                    deleteditem_list: deletedItemRows || []
                }
            })
        }
        else {
            submitLockRef.current = false;
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }

    }
    console.log(rows, "row")
    const handleAddRow = () => {
        setFormData({ ...emptyFormField })
        setOpenDrawer(true)
        setBtnLabel("ADD")
    }
    const funSetStockFormSetting = (column) => {

        if ([formField.rate, formField.rateD].includes(column))
            return true
        else
            return setColumnVisiblity(column)
    }
    const getColumnName = (xlTbCol) => {
        let nameCol = ''
        if (xlTbCol == "s_code") nameCol = "s_name"
        else if (xlTbCol == "sh_code") nameCol = "sh_name"
        else if (xlTbCol == "sz_code") nameCol = "sz_name"
        else if (xlTbCol == "q_code") nameCol = "q_name"
        return nameCol

    }

    const transformExcelData = (excelRows, excelColMapping) => {
        return excelRows.map((row, index) => {
            const rowObj = {};

            excelColMapping.forEach(mapping => {
                const colIndex = parseInt(mapping.xl_col_no, 10) - 1;
                const colName = mapping.tb_col_name;
                const cellValue = row[colIndex] ?? null;

                if (["s_code", "sh_code", "q_code", "sz_code"].includes(colName)) {
                    const nameCol = getColumnName(colName);

                    // Store the Excel name
                    if (nameCol) {
                        rowObj[nameCol] = cellValue;
                    }

                    // Convert the Excel name into its corresponding code
                    rowObj[colName] = funGetCode(colName, cellValue);
                } else {
                    rowObj[colName] = cellValue;
                }
            });

            return {
                ...rowObj,
                id: index + 1,
                detId: 0
            };
        });
    };

    console.log(selRateDate, "date")
    const isDuplicateExcludingId = (target, arr) => {
        const excludeKeys = [
            'id',
            'detId',
            formField.rate,
            formField.rateD,

        ];

        return arr.some(item => {
            // Skip the same row when editing
            if (item.id === target.id) {
                return false;
            }

            return Object.keys(target)
                .filter(key => !excludeKeys.includes(key))
                .every(key => String(item[key] ?? '') === String(target[key] ?? ''));
        });
    };

    const handleAddStock = () => {
        const validate_form = validateForm()

        if (validate_form) {
            let isDuplicate = false
            isDuplicate = isDuplicateExcludingId(formData, rows)

            if (!isDuplicate) {
                if (selectedRowId && selectedRowId != "") {
                    const currentDataIndex = rows.findIndex((ele) => ele.id == selectedRowId);
                    const updateData = { ...rows[currentDataIndex], ...formData }
                    const newData = [...rows]
                    newData[currentDataIndex] = updateData
                    setSelectedRowId("")
                    setRows(newData)
                    setAllRows(newData)
                    // setAllRows(newData)
                    setOpenDrawer(false)
                    // toast.success("Stock Updated.....", {
                    //     "position": "top-center"
                    // })

                }
                else {
                    //if(ref)
                    // setIsFocus(true)


                    const newRow = { id: rows.length + 1, ...formData, }
                    setRows([...rows, newRow])
                    // setAllRows([...allRows, newRow])

                    setFormData({ ...emptyFormField })
                    toast.success("Stock Added.....", {
                        "position": "top-center",
                        onClose: () => {
                            const pktInput = document.querySelector("#pktNo");
                            if (pktInput && typeof pktInput.focus === 'function') {
                                pktInput.focus();
                            }

                        }
                    })

                }

            }
            else {
                show("Duplicate entry not allowed. A row with the same parameter values already exists.")
            }
        }
        else {
            if (!toast.isActive('toats_chkreqrd')) {
                toast.error("Fill all required values", {
                    "position": "top-center",
                    "className": "toast-error",
                    toastId: "toats_chkreqrd",
                })
            }
        }
    }
    const handleConfirmBox = (data) => {

        if (data) {
            if (itemToDelete != "" && itemToDelete != null) {
                FndeleteEntry({
                    data: {
                        rate_date: selRateDate,
                        price_type: selPriceType
                    }
                })
            }

        }
        else {
            setItemToDelete("")
        }

    }
    const handleDeleteEntry = () => {
        setItemToDelete("deleteAll")
    }
    const handleCheckChange = (val) => {
        setIsExcelImport(val)
        if (val == false) {
            setRows([])
            setAllRows([])
        }
        setDuplicateRows([])

    }


    const removeDuplicateRows = (arr) => {
        const excludeKeys = ["id", "detId", "Pr_Rate", "Pr_RateD"];
        const uniqueRows = [];
        const duplicates = [];

        arr.forEach(row => {
            const isDuplicate = uniqueRows.some(existingRow =>
                Object.keys(row)
                    .filter(key => !excludeKeys.includes(key))
                    .every(key => {
                        const value1 = row[key] ?? "";
                        const value2 = existingRow[key] ?? "";

                        return String(value1).trim().toLowerCase() ===
                            String(value2).trim().toLowerCase();
                    })
            );

            if (isDuplicate) {
                duplicates.push(row);
            } else {
                uniqueRows.push(row);
            }
        });

        setDuplicateRows(duplicates);

        // Reset IDs after removing duplicates
        return uniqueRows.map((row, index) => ({
            ...row,
            id: index + 1
        }));
    };


    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();


        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (!rows?.length) return;

            //const mapped = dataRows.filter((r) => r.length !== 0).map((row, ind) => {
            const dataRows = rows.slice(1).filter((r) => r.length !== 0);
            const headers = rows[0]; // Not used here but might be needed elsewhere

            const uploadEXLData = transformExcelData(dataRows, excelTempData);
            const uniqueRows = removeDuplicateRows(uploadEXLData);


            setAllRows(uniqueRows)
            setRows(uniqueRows)
        };

        reader.readAsBinaryString(file);

        // Reset file input so re-selecting same file triggers onChange
        e.target.value = null;
    };

    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];


        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only

        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "PolishPriceImportFormat.xlsx");


    }

    const searchInAllKeys = (data, searchText) => {
        if (!searchText) return data;

        const lowerSearch = searchText.toLowerCase();

        return data.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    };

    useEffect(() => {

        const searchData = searchInAllKeys(allRows, searchText)

        setRows(searchData)

    }, [searchText])
    const hasNewRows = useMemo(() => {

        return rows?.some(
            (row) => Number(row[formField.detId]) === 0)
    }, [rows])

    const handleChangeParams = () => {
        setIsShowDialog(true)
    }
    const handleConfirmFilter = () => {
        setIsShowDialog(false);

        if (selRateDate != "" && selRateDate != null && selRateDate != 'Invalid Date' && selPriceType != "" && selPriceType != null) {
            funFilterData(
                selRateDate,
                selPriceType
            );
        }


    };

    const handleCancelFilter = () => {
        setIsShowDialog(false);
    };
    const handleCancle = () => {
        setSelPriceType("")
        setSelRateDate(dayjs(new Date()).format("YYYY-MM-DD") || null)
    }
    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }

    return (
        <div>
            {itemToDelete && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={ENUM_PAGEACTION_TYPE.Delete}
                />
            )}

            <MainContainer
                pageName={'Polish Price Entry'}
                info={[]}
                breadcrumbs={['Accounts', 'Polish Price Entry']}
            >

                {/* <div className="mb-4 rounded-xl border border-indigo-100 bg-gradient-to-r from-indigo-50 via-white to-blue-50 p-3 shadow-sm"> */}
                <div className="bg-white">

                    <form onSubmit={handleSubmit}>

                        <div className="my-4 sm:my-5 rounded-lg border border-slate-200 bg-white p-3 sm:p-4 shadow-sm">
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 items-end">

                                {/* Price Date Select */}
                                <FormControl fullWidth size="small">
                                    <InputLabel
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: 500,
                                        }}
                                    >
                                        Price Date
                                    </InputLabel>

                                    <Select
                                        value={selRateDate || ""}
                                        onChange={(e) => setSelRateDate(e.target.value)}
                                        label="Price Date"
                                        readOnly={hasNewRows}
                                        sx={{
                                            borderRadius: "8px",
                                            fontSize: "13px",
                                            backgroundColor: hasNewRows ? "#f8fafc" : "#fff",
                                        }}
                                    >
                                        {prDateList.map((p) => (
                                            <MenuItem
                                                key={dayjs(p.RateDate).format("YYYY-MM-DD")}
                                                value={dayjs(p.RateDate).format("YYYY-MM-DD")}
                                            >
                                                {dayjs(p.RateDate).format("DD/MM/YYYY")}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                {/* Price Date Picker */}
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Date"
                                        views={["day", "month", "year"]}
                                        format="DD/MM/YYYY"
                                        value={selRateDate ? dayjs(selRateDate) : null}
                                        onChange={(newValue) => {
                                            setSelRateDate(
                                                newValue?.isValid()
                                                    ? newValue.format("YYYY-MM-DD")
                                                    : null
                                            );
                                        }}
                                        readOnly={hasNewRows}
                                        slotProps={{
                                            field: {
                                                clearable: true,
                                            },
                                            textField: {
                                                onBlur: (e) => handleDateBlur(e, "prDate"),
                                                fullWidth: true,
                                                size: "small",
                                                required: true,
                                                sx: {
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                        fontSize: "13px",
                                                        backgroundColor: hasNewRows
                                                            ? "#f8fafc"
                                                            : "#fff",
                                                    },
                                                    "& .MuiInputLabel-root": {
                                                        fontSize: "13px",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>

                                {/* Price Type */}
                                <div className="min-w-0 w-full">
                                    <AutoCompleteInput
                                        label="Price Type"
                                        value={selPriceType}
                                        name="priceType"
                                        options={priceTypeData || []}
                                        optionKey="PriceType"
                                        optionValue="PriceType"
                                        labelClass="text-xs text-slate-700 font-medium"
                                        cssClass="text-sm"
                                        mWidth="100%"
                                        readOnly={hasNewRows}
                                        onChange={(val) => setSelPriceType(val)}
                                        onSelect={(item) => {

                                        }}
                                        onCreate={(newName) => {

                                        }}
                                    />
                                </div>

                                {/* Change Parameters Action */}
                                {hasNewRows && (
                                    <div className="flex w-full items-center sm:col-span-2 lg:col-span-1">
                                        <Chip
                                            label="Change Price Date / Type"
                                            onClick={handleChangeParams}
                                            color="warning"
                                            variant="outlined"
                                            sx={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                minHeight: 34,
                                                textTransform: "uppercase",
                                                cursor: "pointer",
                                                "& .MuiChip-label": {
                                                    whiteSpace: "normal",
                                                    py: 1,
                                                    fontSize: "12px",
                                                    fontWeight: 600,
                                                },
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>


                        <Card className="h-screen">
                            <CardBody>


                                {/* </div> */}
                                {selRateDate && selRateDate != null && selRateDate != 'Invalid Date' && selPriceType && selPriceType != null && selPriceType != "" && (
                                    <div>
                                        {priceData && priceData.length <= 0 &&
                                            <div className="text-right bg-gray-50 p-2 mb-2">

                                                <Checkbox
                                                    size="md"
                                                    isSelected={isExcelImport}
                                                    onValueChange={handleCheckChange}
                                                    color="danger"
                                                    classNames={{
                                                        base: `
                                                                m-0 h-8 px-3
                                                                rounded-lg
                                                                border
                                                                uppercase
                                                                transition-all duration-200
                                                                ${isExcelImport
                                                                ? "bg-rose-100 border-rose-400 shadow-sm"
                                                                : "bg-rose-50 border-rose-200 hover:bg-rose-50 hover:border-rose-300"
                                                            }
        `,
                                                        wrapper: `
                                                                                    w-5 h-5
                                                                                    border-2 border-rose-500
                                                                                    rounded-md
                                                                                    after:bg-rose-600
                                                                                    after:border-rose-600
        `,
                                                        label: `
            text-xs font-semibold whitespace-nowrap
            ${isExcelImport
                                                                ? "text-rose-700"
                                                                : "text-rose-600"
                                                            }
        `,
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faFileExcel}
                                                        className="mr-2 text-rose-600"
                                                    />
                                                    Import From Excel
                                                </Checkbox>
                                                {isExcelImport &&
                                                    <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className="ml-4 h-6"
                                                        startContent={<FontAwesomeIcon icon={faDownload} />} >
                                                        Import Excel Format
                                                    </Button>}

                                                {isExcelImport &&
                                                    <div className="mt-2">

                                                        <Input type="file" color="success" size="md" variant="flat"
                                                            ref={fileInputRef}
                                                            // className="w-1/2"
                                                            classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                                            // isRequired={isExcelImport}
                                                            label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                                                    </div>}

                                            </div>}

                                        <Drawer open={openDrawer} anchor="top">
                                            {/* <FontAwesomeIcon onClick={() => setOpenDrawer(false)} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} /> */}

                                            <div className="text-center font-semibold uppercase p-1 text-gray-700 border-b-2 border-orange-500">
                                                {`${btnLabel} Polish Price`}
                                            </div>
                                            <div className="p-5">

                                                {
                                                    Object.keys(inputBoxes).map((key, ind) => (
                                                        <div key={key + ind}>
                                                            <div className={` flex gap-4 align-top items-baseline mb-2 `}>
                                                                {
                                                                    inputBoxes[key].map((item, indx) =>
                                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                                            <></>
                                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                                            funSetStockFormSetting(item.name) ?
                                                                                <Autocomplete
                                                                                    size="md"
                                                                                    name={item.name}
                                                                                    label={item?.placeholder}
                                                                                    eventResizeFeature={true}
                                                                                    selectionMode="single"
                                                                                    showScrollIndicators={true}
                                                                                    labelPlacement={"outside"}
                                                                                    placeholder={item.placeholder}
                                                                                    isRequired={item.isrequired}
                                                                                    menuTrigger={"input"}
                                                                                    className="max-w-23"
                                                                                    classNames={{
                                                                                        label: "text-xs text-black font-bold",
                                                                                    }}
                                                                                    isClearable={false}
                                                                                    isVirtualized
                                                                                    variant="bordered"
                                                                                    defaultItems={
                                                                                        item.data ? item.data : []
                                                                                    }
                                                                                    onSelectionChange={(e) =>
                                                                                        handleAutoCompleteChange(e, '', item.name)
                                                                                    }

                                                                                    selectedKey={formData[item.name]}
                                                                                >
                                                                                    {(list) => (
                                                                                        <AutocompleteItem

                                                                                            key={list[item.itemkey]}
                                                                                        >
                                                                                            {list[item.itemvalue]}
                                                                                        </AutocompleteItem>
                                                                                    )}
                                                                                </Autocomplete> : ""
                                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                                            <div className=" w-full flex items-center">
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <DatePicker
                                                                                        label={item.placeholder}
                                                                                        views={["day", "month", "year"]}
                                                                                        format="DD/MM/YYYY"
                                                                                        value={
                                                                                            formData[item.name]
                                                                                                ? dayjs(formData[item.name])
                                                                                                : formData[item.name]
                                                                                        }
                                                                                        onChange={(newValue) => handleDateChange(newValue)}
                                                                                        className="w-full "
                                                                                        slotProps={{
                                                                                            textField: { size: "small", onBlur: (e) => handleDateBlur(e, item.name), required: true },
                                                                                        }}
                                                                                    />
                                                                                </LocalizationProvider>
                                                                            </div>
                                                                        ) : (

                                                                            <Input
                                                                                type={item.type}
                                                                                name={item.name}
                                                                                id={item.name}
                                                                                placeholder={item.placeholder}
                                                                                label={item.placeholder}
                                                                                labelPlacement="outside"
                                                                                isRequired={item.isrequired}
                                                                                value={formData[item.name]}
                                                                                variant="bordered"
                                                                                onChange={(e) => handleChange(e)}


                                                                                size={"md"}
                                                                                classNames={{
                                                                                    label: "text-xs text-black font-bold",
                                                                                }}
                                                                            ></Input>
                                                                        )
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    ))
                                                }

                                                <div className="py-5 text-center justify-center flex gap-4">
                                                    <Button
                                                        color="success"
                                                        size="sm"
                                                        variant="shadow"
                                                        className="uppercase"
                                                        onPress={handleAddStock}
                                                        startContent={<FontAwesomeIcon icon={faPlus} />}
                                                    >
                                                        {btnLabel}
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        variant="shadow"
                                                        className="uppercase"
                                                        onPress={() => setOpenDrawer(false)}
                                                        startContent={<FontAwesomeIcon icon={faClose} />}
                                                    >
                                                        Close
                                                    </Button>
                                                </div>

                                            </div>


                                        </Drawer>
                                        <div className=" flex justify-between ">
                                            {isExcelImport ? "" :
                                                <Button
                                                    size="sm"
                                                    radius="md"
                                                    onPress={handleAddRow}
                                                    startContent={
                                                        <FontAwesomeIcon
                                                            icon={faPlus}
                                                            className="text-white text-xs"
                                                        />
                                                    }
                                                    className="
                                                        h-8 px-4
                                                        bg-gradient-to-r from-emerald-500 to-green-500
                                                        hover:from-emerald-700 hover:to-green-700
                                                        active:scale-95
                                                        text-white text-xs font-semibold
                                                        shadow-sm hover:shadow-md
                                                        transition-all duration-200
                                                    "
                                                >
                                                    ADD ITEM
                                                </Button>}
                                            {priceData && priceData.length > 0 &&
                                                <Button
                                                    size="sm"
                                                    radius="md"
                                                    onPress={handleDeleteEntry}
                                                    startContent={
                                                        <FontAwesomeIcon
                                                            icon={faRemove}
                                                            className="text-white text-xs"
                                                        />
                                                    }
                                                    className="
                                                        h-8 px-4
                                                        bg-gradient-to-r from-red-500 to-red-500
                                                        hover:from-red-700 hover:to-red-700
                                                        active:scale-95
                                                        text-white text-xs font-semibold
                                                        shadow-sm hover:shadow-md
                                                        transition-all duration-200
                                                    "
                                                >
                                                    Delete ALL Entry
                                                </Button>
                                            }
                                        </div>

                                        <div className="my-2">
                                            <Input type="text" size="sm"
                                                radius="none" placeholder="Search ...."
                                                startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                                                variant="bordered" className="bg-white border-1 border-gray-300"
                                                value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                                        </div>
                                        {
                                            rows && rows?.length > 0 ? (
                                                <>

                                                    <Box sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                                        <DataGrid
                                                            rows={rows}
                                                            columns={columns}
                                                            editMode="row"
                                                            columnHeaderHeight={30}
                                                            rowHeight={30}
                                                            disableColumnSorting={true}
                                                            disableColumnMenu={true}
                                                            getRowClassName={(params) => {
                                                                if (params.id == selectedRowId)
                                                                    return 'select-row'
                                                                return 'row-class';
                                                            }}

                                                            // getRowClassName={getRowClassName}
                                                            sx={{
                                                                '& .MuiDataGrid-columnHeaders': {
                                                                    position: 'sticky',
                                                                    top: 0,
                                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                                },
                                                                '& .select-row': {
                                                                    backgroundColor: "#ebe8e8"
                                                                },
                                                                '& .row-class': {
                                                                    fontSize: "12px"
                                                                },
                                                                '& .sticky-row': {
                                                                    position: 'sticky',
                                                                    bottom: 0,
                                                                    color: "#FFFFFF",
                                                                    backgroundColor: '#424242f5',
                                                                    zIndex: 10,
                                                                },
                                                                '& .sticky-row:hover': {
                                                                    backgroundColor: "#424242f5"
                                                                }
                                                            }}
                                                            columnVisibilityModel={{
                                                                [formField.shapeCode]: setColumnVisiblity(formField.shapeCode),
                                                                [formField.colorCode]: setColumnVisiblity(formField.colorCode),
                                                                [formField.purityCode]: setColumnVisiblity(formField.purityCode),
                                                                [formField.sizeCode]: setColumnVisiblity(formField.sizeCode),
                                                                [formField.lwRatio]: setColumnVisiblity(formField.lwRatio),
                                                            }}

                                                        />

                                                    </Box>

                                                </>
                                            ) : (
                                                <NoItemsCard />
                                            )
                                        }
                                        {
                                            isExcelImport && <h2 className="p-2 text-sm font-semibold text-red-700">{`Total No Of Imported Rows : ( ${duplicateRows?.length || 0 + rows?.length || 0} )`}</h2>
                                        }
                                        {

                                            duplicateRows.length > 0 && (
                                                <div className="bg-lime-50 p-2 text-sm mt-2 rounded">
                                                    <h2 className="p-2 text-sm font-semibold text-blue-700">
                                                        {`Duplicate Value Rows : ( ${duplicateRows?.length} )`}
                                                    </h2>

                                                    <div className="flex gap-2 flex-wrap">
                                                        {duplicateRows.map((row, index) => {
                                                            const values = [
                                                                `Shape: ${row.s_name || ""}`,
                                                                `Size: ${row.sz_name || ""}`,
                                                                `Color: ${row.sh_name || ""}`,
                                                                `Purity: ${row.q_name || ""}`,
                                                                `LW: ${row.lw_code ?? ""}`
                                                            ];

                                                            return (
                                                                <div
                                                                    key={`${row.id}-${index}`}
                                                                    className="w-full rounded border border-lime-200 bg-white p-2"
                                                                >
                                                                    <span className="font-semibold text-red-600">
                                                                        {index + 1}.
                                                                    </span>{" "}
                                                                    {values.join(", ")}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="justify-center flex items-center gap-4 my-5">
                                            {/* <div className="justify-center flex gap-5 mt-5"> */}
                                            <Button
                                                color="primary"
                                                type="submit"
                                                id="btnSave"
                                                size="sm"
                                                variant="shadow"
                                                // isDisabled={isExcelImport ? isLoadingDupPktList : false}
                                                isLoading={isPending}
                                                className="uppercase font-semibold"
                                                startContent={<FontAwesomeIcon icon={faSave} />}
                                            >
                                                Submit
                                            </Button>

                                            <Button
                                                color="danger"
                                                variant="shadow"
                                                size="sm"

                                                onPress={handleCancle}
                                                className="uppercase font-semibold"
                                                startContent={<FontAwesomeIcon icon={faCancel} />}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>)}
                            </CardBody>
                        </Card>
                    </form>

                </div>
            </MainContainer >
            {isShowDialog &&
                <WarningDialog
                    open={isShowDialog}
                    onClose={handleCancelFilter}
                    onConfirm={handleConfirmFilter}
                    title="Unsaved Changes"
                    message="You have newly added data that has not been saved."
                    description="If you continue, this data will be lost. Do you want to continue?"
                    confirmText="Continue"
                    cancelText="Cancel"
                />
            }
        </div>
    )
}
export default PriceListEntry
